




























































































import { Component, Prop, Model, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../../sw-extended-vue';
import { SwIconButton } from '../../sw-icon-button';
import { MapControlledLayer } from './types';
import { DetailViewLayerAction } from '../types';
import SwMap from '../sw-map.vue';

/**
 * @event change `(layerId: string)`
 */
@Component({
  components: {
    SwIconButton,
  },
})
export default class SwMapLayer extends SwExtendedVue {
  @Model('change', { type: String, required: true })
  value: string;

  @Prop({ type: Array, required: true })
  layers: MapControlledLayer[];

  cssPrefix: string = 'sw-map-layer';

  get reverseLayers(): MapControlledLayer[] {
    return this.layers.reverse();
  }

  @Inject()
  claimLayerAction: SwMap['claimLayerAction'];

  onSelectLayer(layer: MapControlledLayer) {
    if (layer.id !== this.value) {
      this.$emit('change', layer.id);
    }
  }

  onClickAction(layer: MapControlledLayer, action: DetailViewLayerAction) {
    this.claimLayerAction(layer.id, action.key);
  }
}
